import React from "react"

const _safeTrack = eventPayload => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(eventPayload)
  } else {
    console.log("dataLayer:", "non existent")
  }
}

export const useTrackFormStepArrival = stepName => {
  React.useEffect(() => {
    _safeTrack({
      event: "form_step",
      form_type: "self-schedule",
      form_step: stepName,
    })
  }, [stepName])
}

export const trackFormSubmitSuccess = () => {
  _safeTrack({
    event: "form_complete",
    form_type: "self-schedule",
  })
}
